import { MuiAlert } from '@fox/atoms';
import React from 'react';
import { useContentContext } from '../../content-context';
import { MemberShipFormTemplate } from '../membership-form-template';
import { MembershipFormFieldTypes } from '../membership-form-template/contracts';
import { redirect } from '../membership-form-template/util';
import { IRequestLoginFormProps, RequestLoginFormModel } from './contracts';
import { loginRequestValidationSchema } from './validation-schema';

export const RequestLoginForm: React.FC<IRequestLoginFormProps> = ({
	membershipFieldDisplayName,
	redirectUrl,
	blockContentAbsoluteUri,
	originContentId
}) => {
	const { contentId, requestToken, isLoggedIn } = useContentContext();
	if (isLoggedIn) {
		return (
			<div style={{ padding: '20px 10px', maxWidth: '500px', margin: '0 auto' }}>
				<MuiAlert severity="info">Logged in</MuiAlert>
			</div>
		);
	} else {
		return (
			<MemberShipFormTemplate<RequestLoginFormModel>
				contentId={contentId}
				recaptcha="memberRequestLogin"
				submitButtonText="Request login"
				validationSchema={loginRequestValidationSchema}
				initialValues={{
					email: '',
					membershipFieldValue: '',
					blockContentAbsoluteUri,
					originContentId
				}}
				submitFunction={async values => {
					return await fetch('/Umbraco/Api/Membership/RequestTwoFactorLinkEmail', {
						method: 'POST',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
							RequestVerificationToken: requestToken
						},
						body: JSON.stringify({ ...values, contentId })
					});
				}}
				onSuccessFullSubmit={() => {
					if (redirectUrl?.url) {
						redirect(redirectUrl);
					}
				}}
				fields={[
					{
						name: 'email',
						label: 'Email Address',
						fieldType: MembershipFormFieldTypes.TextField
					},
					{
						name: 'membershipFieldValue',
						label: membershipFieldDisplayName,
						fieldType: MembershipFormFieldTypes.TextField
					}
				]}
			/>
		);
	}
};
